// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTabbedView-Tab_cls1__zKYhH","cls2":"VeloTabbedView-Tab_cls2__BhL9B VeloTabbedView-Tab_cls1__zKYhH"};